import {useState} from "react";
import type {DungeonLevel} from "@/dungeons/model/DungeonLevel.ts";
import {isLightLocked, lightLockKey} from "./LightLockState.ts";

export function useLightLocks(activeLevel?: DungeonLevel) {
    const [toggledLightLocks, setToggledLightLocks] = useState<ReadonlySet<string>>(new Set());
    const toggleLightLock = (key: string) => setToggledLightLocks(current => {
        const next = new Set(current);
        if (next.has(key)) next.delete(key); else next.add(key);
        return next;
    });
    const canMoveLight = (source: "dungeon" | "encounter", id: string) => Boolean(activeLevel)
        && !isLightLocked(source, lightLockKey(activeLevel!.id, id), toggledLightLocks);
    return {toggledLightLocks, toggleLightLock, canMoveLight};
}
